window.VIEW_EVENT = {
    READY: "viewReady",
    LOAD_START: "viewLoadStart",
    LOAD_END: "viewLoadEnd",
};

const LOADED_SCREEN_LIMIT = 0;
var _SCREEN_IS_LOADING = false;
var waitForEl = function(selector, callback) {
    if (selector != null) {
      callback();
    } else {
      setTimeout(function() {
        waitForEl(selector, callback);
      }, 100);
    }
}; 


class ViewController extends Base {
    
    constructor(element, model, persistance) {
        super(element);
        this.persistance = persistance;
        this.model = model;
        this.current_uid = null;
        this.screen = new Screen(this.model, this.persistance);
        this.lastLoadedScreen = null;

        if (config.modalVoltar.active) {
            var returnModal = new ReturnModal(window, document, config, this.loadFirst.bind(this));
        }
        else{
            this.loadFirst();
        }
    }


    loadFirst() {
        console.log("Modo: " + window.scorm.persistance.name);
      
        if(window.scorm.persistance.name == 'localStorage'){
            this.scormReturn(true);
        }else{
            console.log("Iniciando busca da API SCORM.");
            do {
                this.scormReturn(false);
            } while (window.scorm.scorm.scorm.connection.isActive == false);
        }

        bridge.hiddeViewsFromReaderScreen = function() {
            var elements = '*';
        
            $(elements).each(function() {
                if ($(this).css("opacity") == 0) {
                    $(this).attr("aria-hidden", "true");
                } else {
                    $(this).attr("aria-hidden", "false");
                }
            });
        };

        bridge.fullScreenControll = function(full_element){
            var elem = document.getElementById("main");

            $(full_element).attr("full", "close");

            $( full_element ).on('click', function(e) {
                e.preventDefault();
                if (document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitExitFullscreen) { /* Safari */
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) { /* IE11 */
                        document.msExitFullscreen();
                    }
                }
                else
                {
                    if (elem.requestFullscreen) {
                        elem.requestFullscreen();
                    } else if (elem.webkitRequestFullscreen) { /* Safari */
                        elem.webkitRequestFullscreen();
                    } else if (elem.msRequestFullscreen) { /* IE11 */
                        elem.msRequestFullscreen();
                    }
    
                }
            });

             
            if (document.addEventListener)
            {
                document.addEventListener('fullscreenchange', changeFullAtrrHandler, false);
                document.addEventListener('mozfullscreenchange', changeFullAtrrHandler, false);
                document.addEventListener('MSFullscreenChange', changeFullAtrrHandler, false);
                document.addEventListener('webkitfullscreenchange', changeFullAtrrHandler, false);
            }

            function changeFullAtrrHandler()
            {
                if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement)
                {
                    $(full_element).attr("full", "close");
                }else{
                    $(full_element).attr("full", "open");
                }
            }
            
        }



        this.screen.current.loadPageEvents(this.screen.current);


        
        
    }

    scormReturn(localData) {
        
        if(window.scorm.scorm.scorm.connection.isActive == true || localData == true){

            if(window.scorm.scorm.scorm.connection.isActive){
                console.log("CONEXÃO ESTABELECIDA COM A API SCORM");
            }
            this.current_uid = this.persistance.get(SCORM_API.LESSON_LOCATION) || null;
            let firstScreen = this.screen.first();
            if (typeof this.current_uid == 'string') {
                firstScreen = this.screen.selectPage(this.current_uid);
            }
            this.loadScreen(firstScreen).then(() => {
                firstScreen.element.classList.add('first-screen');
                firstScreen.element.classList.remove('out');
                firstScreen.element.classList.add('in');
                $(window).trigger(VIEW_EVENT.READY);
                firstScreen.enterView();
            });
          }
    }

    loadScreen(screen) {

        if (this.children.length > LOADED_SCREEN_LIMIT) {
            this.removeChildFirst();
        }


        return new Promise((res, rej) => {
            
            screen.render();
            screen.element.classList.add('out');
            var navigationDirection = "";

            if(this.lastLoadedScreen != null){
                var lastIndex = this.getPageIndexById(this.lastLoadedScreen.uid);

                if(this.screen.index < lastIndex){
                    navigationDirection = "prev";
                }else if(this.screen.index > lastIndex){
                    navigationDirection = "next";
                }else{
                    navigationDirection = "notChanged";
                }
            }else{
                navigationDirection = "first";
            }

            screen.element.onload = () => {
                
                screen  
                    .inject('navigate', {
                        goto: this.goto.bind(this),
                        next: this.next.bind(this),
                        prev: this.prev.bind(this),
                        currentScreen: this.screen,
                        currentScreenUid: this.screen.model.pages[this.screen.index].uid,
                        pagesTotal: this.screen.model.pages.length,
                        pageIndexConfigPosition: this.screen.index,
                        lastLoadedScreen: this.lastLoadedScreen,
                        loadedDirection: navigationDirection
                        
                    })
                    .inject('engine_config', {
                        config: config,
                    })
                    .inject('scorm', this.persistance)
                    .inject('bridge', bridge)
                    .onready() 
                res(screen);
            };
            
            this.appendChild(screen);
        });
        
        
    }

    getPageIndexById(_id){
        for (var i=0; i< config.pages.length;i++) {
           if(_id ==  config.pages[i].uid){
               return i;
           }
        }
    }


    goto(uid) {
        let next = null;
        let direction = true;
        let current = this.screen.getCurrentScreen();

        

        this.lastLoadedScreen = current;

        if(!_SCREEN_IS_LOADING){
           
            if (uid == "_next") {
                next = this.screen.next();
            } else if (uid == "_prev") {
                next = this.screen.prev();
                direction = false;
            } else {
                next = this.screen.selectPage(uid);
            }
            if (next && next.uid != current.uid) {
                this.current_uid = next.model.uid;
    
                $(window).trigger(VIEW_EVENT.LOAD_START);
                _SCREEN_IS_LOADING = true;
                
                
                this.loadScreen(next).then(() => {
                    current.exitView();
                    next.enterView();
                    this.updateSlidesStates(direction, current.element, next.element);
                    this.persistance.set(SCORM_API.LESSON_LOCATION, next.model.uid);
                    $(window).trigger({
                        type: VIEW_EVENT.LOAD_END,
                        screen: next
                    });
    
                    _SCREEN_IS_LOADING = false;
                    
                });

                next.loadPageEvents(next);
               

                return true;
            }
        }
        
    }



    updateSlidesStates(avanca, currentSlide, nextSlide) {
        
        currentSlide.classList.remove('first-screen');
        nextSlide.classList.remove('first-screen');
        if (avanca) {
            currentSlide.classList.add('in');
        } else {
            currentSlide.classList.remove('in');
        }
        currentSlide.classList.add('out');
        nextSlide.classList.remove('out');
        nextSlide.classList.add('in');
    }

    next() {
        this.goto('_next');
    }

    prev() {
        this.goto('_prev');
    }
}